import React, {useEffect, useState} from "react";
import {Card, Col, Row, Spinner, Button} from "reactstrap";
import {CustomInput} from "../../Common/Components/Input/CustomInput";
import {CustomSubmitButton} from "../../Common/Components/Input/CustomSubmitButton";
import useApiCallService from "../../Common/Helpers/ApiCall";
import {FlashMessage} from "../../Common/Helpers/FlashMessage";
import {ADMIN_PATHS} from "../../config";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {CheckDecimal} from "../../Common/Helpers/CheckDecimal";
import AdminRequestHonorariumCreate from "../Models/Request/AdminRequestHonorariumCreate";
import AdminRequestHonorariumUpdate from "../Models/Request/AdminRequestHonorariumUpdate";
import AdminResponseHonorarium from "../Models/Response/AdminResponseHonorarium";
import $ from "jquery";
import {CustomReload} from "../../AppSystem/Helpers/CustomReload";
import {InfoPageMessage} from "../../Common/Components/Button/InfoPageMessage";
import {LoadingData} from "../../Common/Components/LoadingData";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import {ChangeDateFormat} from "../../Common/Helpers/ChangeDateFormat";
import {InputMessage} from "../../AppSystem/Helpers/InputMessage";
import {CustomModal} from "../../Common/Components/Modal/CustomModal";
import {CheckUserPermission} from "../../AppSystem/Helpers/CheckUserPermission";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";
import { CheckMobile } from "../../AppSystem/Helpers/CheckMobile";

export function AdminHonorariumForm() {
    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();
    const { t } = useTranslation();
    const { ApiCall } = useApiCallService();
    const navigate = useNavigate();
    const isMobile = CheckMobile(998);

    // Detectar si es modo edición o creación
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id') ?? "";
    const isEditMode = id !== "";

    const [honorarium, setHonorarium] = useState(
        isEditMode ? new AdminResponseHonorarium() : new AdminRequestHonorariumCreate()
    );
    const [responseHonorarium, setResponseHonorarium] = useState(new AdminResponseHonorarium());
    const [responseDelete, setResponseDelete] = useState(null);

    const [apiResponseUser, setApiResponseUser] = useState('');
    const [apiResponseOrg, setApiResponseOrg] = useState(null);

    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedOrg, setSelectedOrg] = useState(null);

    const [costJson, setCostJson] = useState({});
    const [jsonUsers, setJsonUsers] = useState({});
    const [jsonOrg, setJsonOrg] = useState({});

    const [isSend, setIsSend] = useState(false);
    const [isErrorAcountMissing, setIsErrorAcountMissing] = useState(false);

    const [costResponse, setCostResponse] = useState(null);
    const [costSelected, setCostSelected] = useState(null);

    const [displaySpinner, setDisplaySpinner] = useState(false);
    const [hideFieldNotValidated, setHideFieldNotValidated] = useState(false);

    const [errorMessage, setErrorMessage] = useState('');

    // MODALS
    const [displaySendModal, setDisplaySendModal] = useState(false);
    const [displaySendDraftModal, setDisplaySendDraftModal] = useState(false);
    const [displayDeleteHonorariumModal, setDisplayDeleteHonorariumModal] = useState(false);

    let permission = false;
    if (CheckUserPermission("admin") || CheckUserPermission("admin.honorarium") || 
        CheckUserPermission("admin.honorarium.update") || CheckUserPermission("admin.honorarium.create")) {
        permission = true;
    }

    useEffect(() => {
        setPageTitle(isEditMode ? t('honorarium.update') : t('honorarium.create'));
        setPageTitleKey('honorarium.update');
        setOnBack(() => navigate(ADMIN_PATHS.HONORARIUM_LIST));
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [isEditMode, t]);

    // GET HONORARIUM (solo en modo edición)
    useEffect(() => {
        if (isEditMode && id !== "") {
            const handleApiResponse = (apiResponse) => {
                setHonorarium(new AdminResponseHonorarium(apiResponse));
                if (apiResponse.orgId) {
                    setSelectedOrg(apiResponse.orgId);
                }
                if (apiResponse.userId) {
                    setSelectedUser(apiResponse.userId);
                }
            };
            const fetchData = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: `/honorarium/admin?id=${id}`
                    };
                    await ApiCall(apiCallOptions, handleApiResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };
            fetchData();
        }
    }, [isEditMode, id]);

    // GET ORGANIZATIONS FOR SELECT
    useEffect(() => {
        const orgData = async () => {
            try {
                const apiCallOptions = {
                    method: "get",
                    url: "/org/list-dropdown",
                };
                ApiCall(apiCallOptions, setApiResponseOrg);
            } catch (error) {
                console.log('error', error);
            }
        };
        orgData();
    }, []);

    // GET USERS FOR SELECT
    useEffect(() => {
        if (selectedOrg !== null) {
            const handleApiResponse = (apiResponse) => {
                setApiResponseUser(apiResponse);
            };
            const userData = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: "/org/users/search/filter?page=1&perPage=1000&organizationId=" + selectedOrg,
                    };
                    await ApiCall(apiCallOptions, handleApiResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };
            userData();
        }
    }, [selectedOrg]);

    // VERIFICAR CUENTA DE USUARIO (solo en modo creación)
    useEffect(() => {
        if (!isEditMode && selectedUser !== null) {
            setIsErrorAcountMissing(false);
            const handleApiUserSettingsResponse = (apiResponse) => {
                if(apiResponse){
                    if(!apiResponse.accountNumber && !apiResponse.clearingNumber){
                        setIsErrorAcountMissing(true);
                    }
                }
            };
            const verifyUserSettingsData = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: "/usersetting/account?userId=" + selectedUser,
                    };
                    await ApiCall(apiCallOptions, handleApiUserSettingsResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };
            verifyUserSettingsData();
        }
    }, [selectedUser, isEditMode]);

    // API CALL TO GET COST BEARER
    useEffect(() => {
        if (selectedOrg !== null) {
            const handleCostResponse = (costResponse) => {
                setCostResponse(costResponse);
            };
            const CostApiCall = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: "/costbearer/list-org?id=" + selectedOrg,
                    };
                    await ApiCall(apiCallOptions, handleCostResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };
            CostApiCall();
        }
    }, [selectedOrg]);

    useEffect(() => {
        if (costResponse !== null) {
            const costBearerArray = [];
            costResponse.forEach((item) => {
                costBearerArray.push({
                    id: item.id,
                    name: item.name,
                });
            });
            setCostJson({
                costBearer: costBearerArray
            });
        }
    }, [costResponse]);

    useEffect(() => {
        if (apiResponseUser !== null && apiResponseUser !== '' && apiResponseUser.items) {
            const userArray = [];
            apiResponseUser.items.forEach((item) => {
                userArray.push({
                    id: item.id,
                    firstName: item.firstName,
                    lastName: item.lastName,
                });
            });
            setJsonUsers({
                userId: userArray,
            });
        }
    }, [apiResponseUser]);

    useEffect(() => {
        if (apiResponseOrg !== null && apiResponseOrg.items && apiResponseOrg.items.length > 0) {
            const orgArray = [];
            apiResponseOrg.items.forEach((item) => {
                orgArray.push({
                    id: item.id,
                    name: item.name,
                    type: item.type
                });
            });
            setJsonOrg({
                orgId: orgArray,
            });
        }
    }, [apiResponseOrg]);

    const handleChangeHonorarium = (e, name) => {
        let value;
        if (name === 'paymentInterval') {
            if (e && e.target && e.target.value) {
                value = parseInt(e.target.value);
            } else {
                value = 0;
            }
        }
        if (name === 'annualHonorarium') {
            if (e && e.target && e.target.value) {
                value = CheckDecimal(e.target.value);
            } else {
                value = 0;
            }
        }
        if (name === 'firstPayment') {
            value = ChangeDateFormat('date', e);
        }
        if (name === "orgId") {
            if (apiResponseOrg !== null && apiResponseOrg.items && apiResponseOrg.items.length > 0) {
                apiResponseOrg.items.map(item => {
                    if (e.value !== undefined) {
                        if (item.id === e.value) {
                            setSelectedOrg(item.id);
                            value = e.value;
                        }
                    }
                });
            } else {
                value = '';
            }
        }
        if (name === "userId") {
            if (apiResponseUser !== null && apiResponseUser !== '' && apiResponseUser.items) {
                apiResponseUser.items.map(item => {
                    if (e.value !== undefined) {
                        if (item.id === e.value) {
                            setSelectedUser(item.id);
                            value = e.value;
                        }
                    }
                });
            }
        }
        if (name === "costBearerId" && costResponse !== null) {
            costResponse.forEach(item => {
                if (item.id === e.target.value) {
                    setCostSelected(item.id);
                    value = e.target.value;
                }
            });
        }
        if (name === "extraInfo") {
            if (e && e.target && e.target.value) {
                value = e.target.value;
            }
        }
        setHonorarium((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));
    }

    const handleValidation = async (status) => {
        $('#submitHonorarium').prop('disabled', true);
        const isDraft = status === "Förslag";
        
        const ModelToUse = isEditMode ? AdminRequestHonorariumUpdate : AdminRequestHonorariumCreate;
        const schemaToUse = ModelToUse.getAttributes(null, true, null, null, isDraft);
        
        try {
            await schemaToUse.validate(honorarium, { abortEarly: false });
            
            setDisplaySpinner(true);
            if (honorarium && honorarium.userId !== "") {

                if (status) {
                    honorarium.status = status;
                }

                const apiCallOptions = {
                    method: isEditMode ? "put" : "post",
                    url: "/honorarium/admin",
                    data: honorarium,
                };
                try {
                    await ApiCall(apiCallOptions, setResponseHonorarium, setErrorMessage);
                } catch (error) {
                    setDisplaySpinner(false);
                    console.log(error);
                    FlashMessage(t('validationMessage.sendError'), 'flash-messageError');
                    $('#submitHonorarium').prop('disabled', false);
                }
            }
        } catch (err) {
            console.log(err);
            $('#submitHonorarium').prop('disabled', false);
        }
    }
    
    useEffect(() => {
        if (errorMessage !== '') {        
            if (errorMessage === 'UserWithoutPnr') {
                FlashMessage('Användaren har inte Pnr , därför är det inte möjligt att behandla denna begäran.', 'flash-messageError', 4500);
            }
            else if (errorMessage === 'AccountNumberInHonorariumIsMandatory') {
                $('#saveReimbursement').prop('disabled', false);
                setDisplaySpinner(false);
                FlashMessage(t('honorarium.missingAccount'), 'flash-messageError', 4000);
                return;
            }
            else{
                FlashMessage(t('validationMessage.sendError'), 'flash-messageError');
            }  
            setTimeout(()=>{CustomReload();},4800);
        }
    }, [errorMessage]);

    // REDIRECT TO INFO PAGE
    useEffect(() => {
        if (responseHonorarium && responseHonorarium.id !== "") {
            const message = isEditMode 
                ? t('validationMessage.honorariumUpdate')
                : t('validationMessage.honorariumSuccessfully');
            FlashMessage(message, 'flash-messageSuccess');
            setTimeout(()=>{
                navigate(`${ADMIN_PATHS.HONORARIUM_INFO}?id=${responseHonorarium.id}`);
            },2000);
        }
    }, [responseHonorarium, isEditMode]);

    // TODO: MOVE TO CUSTOM INPUT
    const annualHonorariumInput = document.getElementById('annualHonorarium');
    if (annualHonorariumInput) {
        annualHonorariumInput.addEventListener('keypress', function(e) {
            const key = e.key;
            if (!((key >= '0' && key <= '9') || key === '.' || key === ',')) {
                e.preventDefault();
            }
        });
    }

    const messageCostBearer = InputMessage(costResponse, costSelected);

    // CHECK REQUIRED INPUTS
    const CheckRequired = () => {
        $("#orgId").focus();
        $("#userId").focus();
        $("#firstPayment").focus();
        $("#paymentInterval").focus();
        $("#costBearerId").focus();
        $("#annualHonorarium").focus();
        setTimeout(() => {
            $('.react-datepicker__tab-loop').addClass('d-none');
            $("#orgId").blur();
            $("#userId").blur();
            $("#firstPayment").blur();
            $("#paymentInterval").blur();
            $("#costBearerId").blur();
            $("#annualHonorarium").blur();
        },1);
        if (honorarium.date === "" || honorarium.orgId === "" || honorarium.purpose === "" || 
            honorarium.costBearerId === "" || honorarium.annualHonorarium === 0 || 
            honorarium.firstPayment === "" || honorarium.paymentInterval === "") {
            return false;
        }
        return true;
    }

    const CheckRequiredDraft = () => {
        $("#orgId").focus();
        $("#userId").focus();

        setTimeout(() => {
            $('.react-datepicker__tab-loop').addClass('d-none');
            $("#orgId").blur();
            $("#userId").blur();
        },1);
        if (honorarium.orgId === "") {
            return false;
        }
        setHideFieldNotValidated(true);
        return true;
    }

    // HANDLE DELETE (solo en modo edición)
    const HandleDeleteHonorarium = async () => {
        if (id !== "") {
            const apiCallOptions = {
                method: "delete",
                url: `/honorarium`,
                data: {id: id}
            };
            try {
                await ApiCall(apiCallOptions, setResponseDelete);
                setDisplayDeleteHonorariumModal(false);
            } catch (error) {
                console.log({error});
            }
        }
    }

    useEffect(() => {
        if (responseDelete !== null) {
            try {
                if (typeof window !== 'undefined' && window.localStorage) {
                    Object.keys(window.localStorage).forEach(key => {
                        if (key.startsWith('honorariumList')) {
                            window.localStorage.removeItem(key);
                        }
                    });
                }
            } catch (e) {
                console.warn('Error clearing honorariumList keys from localStorage', e);
            }
            CustomReload(ADMIN_PATHS.HONORARIUM_LIST);
        }
    }, [responseDelete]);

    // MODALS
    const modalSendContent = (
        <div id="sendMessageDiv">
            {t('honorarium.honorariumModalSend')}
        </div>
    );
    const modalSendFooter = (
        <>
            <Button className="box-green border-0" id="sendButton" onClick={async () => {
                setDisplaySendModal(false);
                await handleValidation(isEditMode ? "Skickat" : undefined);
            }}>
                {t('button.send')}
            </Button>
            <Button className="box-red border-0" onClick={() => {
                setDisplaySendModal(false);
                $("#forms").removeClass("d-none");
            }}>{t('button.cancel')}</Button>
        </>
    );

    const modalSendDraftContent = (
        <div id="sendMessageDiv">
            {t('honorarium.honorariumModalDraft')}
        </div>
    );
    const modalSendDraftFooter = (
        <>
            <Button className="box-green border-0" id="sendButton" onClick={async () => {
                setDisplaySendDraftModal(false);
                await handleValidation("Förslag");
            }}>
                {t('button.save')}
            </Button>
            <Button className="box-red border-0" onClick={() => {
                setDisplaySendDraftModal(false);
                $("#forms").removeClass("d-none");
            }}>{t('button.cancel')}</Button>
        </>
    );

    const modalContentDeleteHonorariumModal = (
        <div>
            {`${t('validationMessage.modalVar')}?`}
        </div>
    );
    const modalFooterDeleteHonorariumModal = (
        <>
            <Button className="box-green border-0" onClick={HandleDeleteHonorarium}>
                {t('button.delete')}
            </Button>
            <Button className="box-red border-0" onClick={() => setDisplayDeleteHonorariumModal(false)}>
                {t('button.cancel')}
            </Button>
        </>
    );

    const ModelToUse = isEditMode ? AdminRequestHonorariumUpdate : AdminRequestHonorariumCreate;

    return(
        <>
            <CustomModal isOpen={displaySendModal} toggle={() => setDisplaySendModal(!displaySendModal)} 
                body={modalSendContent} footer={modalSendFooter} />
            <CustomModal isOpen={displaySendDraftModal} toggle={() => setDisplaySendDraftModal(!displaySendDraftModal)} 
                body={modalSendDraftContent} footer={modalSendDraftFooter} />
            {isEditMode && (
                <CustomModal isOpen={displayDeleteHonorariumModal} 
                    toggle={() => setDisplayDeleteHonorariumModal(!displayDeleteHonorariumModal)} 
                    body={modalContentDeleteHonorariumModal} footer={modalFooterDeleteHonorariumModal} />
            )}
            
            {!isMobile && (
                <Col>
                    <CustomButton text={t('button.back')} icon={'bx bx-chevron-left'} buttonSize={'small'} 
                        customClasses={'mb-3 ms-3'} onClick={() => {
                            navigate(ADMIN_PATHS.HONORARIUM_LIST);
                        }} />
                </Col>
            )}
            <Row className="pb-5 mx-0 px-0">
                <Col lg={6} className="mx-0 px-0">
                    <Card className="card-backend p-4">
                        <Row>
                            <Col xs='auto'>
                                <h2 className='rokkitt-font'>
                                    {isEditMode ? t('honorarium.update') : t('honorarium.create')}
                                </h2>
                            </Col>
                            <InfoPageMessage message={'Test: message create/update Honorarium'}/>
                        </Row>
                        {apiResponseOrg !== null && apiResponseOrg !== '' ?
                            <Row>
                                {/* ORGANIZACIÓN */}
                                <Col lg={6} id="orgDiv">
                                    <CustomInput 
                                        model={ModelToUse} 
                                        attribute='orgId' 
                                        data={honorarium.orgId} 
                                        customChange={(e) => {
                                            handleChangeHonorarium(e, 'orgId');
                                            setSelectedUser(null);
                                            handleChangeHonorarium({ target: { value: '' } }, 'userId');
                                            setJsonUsers({});
                                            setCostSelected(null);
                                            setHonorarium((prevFormData) => ({
                                                ...prevFormData,
                                                userId: "",
                                                costBearerId: ""
                                            }));
                                        }} 
                                        customOptions={jsonOrg}
                                    />
                                </Col>

                                {/* USUARIO */}
                                <Col lg={6} id="userDiv">
                                    {selectedOrg !== null ?
                                        <CustomInput 
                                            model={ModelToUse} 
                                            attribute='userId' 
                                            data={honorarium.userId} 
                                            customChange={(e) => {
                                                handleChangeHonorarium(e, 'userId');
                                            }} 
                                            customOptions={jsonUsers}
                                        />
                                        : '' 
                                    }
                                </Col>

                                {!hideFieldNotValidated ? 
                                <>
                                    <Col lg={6}>
                                        <CustomInput model={ModelToUse} attribute='firstPayment' 
                                            data={honorarium.firstPayment || ''} 
                                            customChange={(e) => handleChangeHonorarium(e, 'firstPayment')} />
                                    </Col>
                                    <Col lg={6}>
                                        <CustomInput model={ModelToUse} attribute='paymentInterval' 
                                            data={honorarium.paymentInterval > 0 ? honorarium.paymentInterval : ''} 
                                            customChange={(e) => handleChangeHonorarium(e, 'paymentInterval')}/>
                                    </Col>
                                    <Col lg={6}>
                                        <CustomInput model={ModelToUse} attribute='annualHonorarium' 
                                            data={honorarium.annualHonorarium || ''} 
                                            customChange={(e) => handleChangeHonorarium(e, 'annualHonorarium')}/>
                                    </Col>
                                    <Col lg={6}>
                                        <CustomInput model={ModelToUse} attribute='extraInfo' 
                                            data={honorarium.extraInfo || ''} 
                                            customChange={(e) => handleChangeHonorarium(e, 'extraInfo')}/>
                                    </Col>
                                    <Col lg={6}>
                                        {costResponse !== null && selectedOrg != null ?
                                            <>
                                                <CustomInput model={ModelToUse} attribute='costBearerId' 
                                                    data={honorarium.costBearerId} 
                                                    customChange={(e) => {
                                                        handleChangeHonorarium(e, 'costBearerId');
                                                    }} customOptions={costJson}/>
                                                {messageCostBearer}
                                            </>
                                            : ''}
                                    </Col>
                                </> 
                                : ''}
                                {!isEditMode && isErrorAcountMissing === true ? 
                                    <Col lg={12} xs='auto'>
                                        <span style={{ color: 'red' }}>{t('modelLabel.missingAccount')}</span>
                                    </Col>
                                : '' }
                                <Col lg={12} className="text-end pt-5">
                                    {isEditMode && id !== "" && (
                                        <Button className="rounded-2 box-red border-0 me-2" 
                                            onClick={() => setDisplayDeleteHonorariumModal(true)}>
                                            <i className="bx bx-x-circle fs-5 pe-1"/> {t("button.delete")}
                                        </Button>
                                    )}
                                    <CustomSubmitButton customClass="me-2" text={t('button.saveReimbursement')} 
                                        id='saveReimbursement' icon='bx bx-save pe-2' doClick={false}
                                        customClick={async () => {
                                            if (CheckRequiredDraft()) {
                                                $("#forms").addClass("d-none");
                                                setIsSend(false);
                                                $('#saveReimbursement').prop('disabled', true);
                                                await handleValidation("Förslag");
                                            }
                                        }}
                                    />
                                    {displaySpinner === true ?
                                        <>
                                            {t('validationMessage.sendingHonorarium')} 
                                            <Spinner color='success' className="me-3" />
                                        </>
                                    : ''}
                                    <CustomSubmitButton text={t('button.send')} id='submitHonorarium' 
                                        icon='bx bx-send pe-2' customClick={async () => {
                                            if (CheckRequired()) {
                                                $("#forms").addClass("d-none");
                                                setIsSend(false);
                                                setDisplaySendModal(true);
                                            }
                                        }} />
                                </Col>
                            </Row>
                            :
                            <LoadingData data={apiResponseOrg}/>}
                    </Card>
                </Col>
            </Row>
        </>
    )
}